import { useRef } from "react";
import { FaChevronLeft, FaChevronRight, FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import SingleProduct from "./SingleProduct";

const ProductList = ({ products, name, disabled = false, hideButton=false }) => {
  const scrollContainerRef = useRef(null);
  const history = useHistory();

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  // Map homepage section name (display) to backend tag used for filtering
  const nameToCategoryTag = {
    "Exclusively Available With Us": "Exclusive",
    "Coming Soon": "Coming Soon",
    "Combinations Titles": "Combo",
    "Rare Titles": "Rare",
    "On Discount/Special Offer": "On Discount",
    "Compilations Titles": "Compilations",
    "Prebooking": "Prebooking",
    "Bestseller": "Bestseller",
    "Latest Releases": "Latest Releases",
    "Pre-Owned and Old Pressings": "Pre-Owned and Old Pressings",
    "Recently Added": "Recently Added",
  };
  const categoryTag = nameToCategoryTag[name] ?? name;

  const handleViewMore = () => {
    history.push(`/products?category=${encodeURIComponent(categoryTag)}`);
  };
  return (
    <div className="relative mb-5 mt-5">
      {products.length > 0 ? (
        <div className="relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold">{name}</h2>
            <div className="hidden sm:flex space-x-2">
              <button
                onClick={scrollLeft}
                className="p-2 rounded-full bg-gray-300 hover:bg-gray-400"
              >
                <FaChevronLeft />
              </button>
              <button
                onClick={scrollRight}
                className="p-2 rounded-full bg-gray-300 hover:bg-gray-400"
              >
                <FaChevronRight />
              </button>
            </div>
          </div>
          <main
            ref={scrollContainerRef}
            className="flex gap-6 overflow-x-auto overflow-y-hidden scroll-smooth items-stretch scrollbar-hide-mobile"
          >
            {products.map((product) => (
              <div key={product.product_id} className="flex-shrink-0 w-56 min-h-[26rem] sm:w-60 sm:min-h-[30rem] md:w-64 md:min-h-[34rem]">
                <SingleProduct
                  product={{
                    _id: product.product_id,
                    qty: 0,
                    name: product.title,
                    description: product.description,
                    brand: product.category,
                    type: product.product_type,
                    category: "Sports",
                    gender: "Men",
                    weight: "200g",
                    quantity: product.qty_available,
                    image: product.product_images[0],
                    rating: 4.5,
                    price: product.mrp,
                    newPrice: product.selling_price,
                    trending: true,
                    label: product.label,
                    condition_type: product.condition_type,
                  }}
                  disabled={disabled}
                  name={name}
                />
              </div>
            ))}
            {!hideButton && (
              <button
                onClick={handleViewMore}
                className="flex-shrink-0 w-56 sm:w-60 md:w-64 min-h-[26rem] sm:min-h-[30rem] md:min-h-[34rem] flex items-center justify-center gap-2 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50/80 hover:border-amber-500 hover:bg-amber-50/50 text-gray-700 hover:text-amber-700 font-semibold text-sm transition-colors"
              >
                VIEW MORE
                <FaArrowRight className="text-lg shrink-0" />
              </button>
            )}
          </main>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ProductList;
